import { Injectable } from '@angular/core';
import { BehaviorSubject, skipWhile, tap } from 'rxjs';
import { ColSort } from './sort';
import { SortDirection } from './sort-direction';

@Injectable()
export class IndexSummaryTableService {

    private _sourceTableData: BehaviorSubject<any[]> = new BehaviorSubject(null);
    private _sourceTableData$ = this._sourceTableData.asObservable();

    private _activeSort: BehaviorSubject<ColSort> = new BehaviorSubject(null);

    private _displayTableData: BehaviorSubject<any[]> = new BehaviorSubject(null);

    displayTableData$ = this._displayTableData.asObservable();
    activeSort$ = this._activeSort.asObservable();

    constructor() {
        this.activeSort$
            .pipe(
                skipWhile(activeSort => !activeSort),
                tap(() => {
                    this.OrganizeData();
                })
            ).subscribe();

        this._sourceTableData$
            .pipe(
                skipWhile(sourceTableData => !sourceTableData),
                tap(() => {
                    this.OrganizeData();
                })
            ).subscribe();
    }

    onSort(newSortState: ColSort) {
        this._activeSort.next(newSortState);
    }

    setDisplayTableDataObs(tableData: any[]) {
        this._displayTableData.next(tableData);
    }

    setSourceTableDataObs(tableData: any[]) {
        this._sourceTableData.next(tableData);
    }

    sort(colSort: ColSort, DataToSort: any[]): any[] {
        var sorted: any[];
        
        sorted = DataToSort.sort((a, b) => {
            const left = typeof a[colSort.column] === 'string' ? a[colSort.column].toLocaleLowerCase() : a[colSort.column];
            const right = typeof a[colSort.column] === 'string' ? b[colSort.column].toLocaleLowerCase() : b[colSort.column];

            if (colSort.state == SortDirection.ASCENDING) {
                return left > right ? 1 : -1;
            } else if (colSort.state == SortDirection.DESCENDING) {
                return left < right ? 1 : -1;
            }

            return 0;
        })

        return sorted;
    }

    OrganizeData(): void {
        let temp = this._sourceTableData?.value;
        if (!temp) {
            return;
        }

        if (this._activeSort?.value) {
            temp = this.sort(this._activeSort.value, temp);
        }

        this.setDisplayTableDataObs(temp);
    }
}